module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vbl-input', {
    ref: "flatpickrInput",
    attrs: {
      "readonly": "",
      "clear": ""
    },
    on: {
      "clear": _vm.clear
    },
    model: {
      value: (_vm.dataValue),
      callback: function($$v) {
        _vm.dataValue = $$v
      },
      expression: "dataValue"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77958e1d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblDatetime/src/vblDatetime.vue
// module id = 282
// module chunks = 0